export default __webpack_public_path__ + "static/media/mo-lottery-fig4.4c131311.webp";